// extracted by mini-css-extract-plugin
module.exports = {"promotionButton":"Promotion_promotionButton__4FiPd","isActive":"Promotion_isActive__t3rte"};